
import * as api from "../../../../api"; 


  
export const createNewList = (APIData) => async (dispatch)=>{
    try {
        const {data } = await api.createNewList(APIData);
        // console.log(data)
        if(data){ return data ;}else if(data?.logout){   dispatch({type:"LOGOUT"});}
        
        
     } catch (error) {
       
    }
}


export const getAllListsByApp = (APIData) => async (dispatch)=>{
  try {
      const {data } = await api.getAllListsByApp(APIData);
    
      if(data){  return data ;}else if(data?.logout){   dispatch({type:"LOGOUT"});}
      
   } catch (error) {
     
  }
}




export const addFolderToListAPI = (APIData) => async (dispatch)=>{
  try {
      const {data } = await api.addFolderToListAPI(APIData);
    
      if(data){  return data ;}else if(data?.logout){   dispatch({type:"LOGOUT"});}
      
   } catch (error) {
     
  }
}




export const getAllFileListByUser = (APIData) => async (dispatch)=>{
  try {
      const {data } = await api?.getAllFileListByUser(APIData);
    
      if(data){  return data ;}
      
   } catch (error) {
     
  }
}

export const manageFileListNamesByUser = (APIData) => async (dispatch)=>{
  try {
      const {data } = await api?.manageFileListNamesByUser(APIData);
    
      if(data){  return data ;}
      
   } catch (error) {
     
  }
}
export const createNewFileListEntryByUser = (APIData) => async (dispatch)=>{
  try {
      const {data } = await api?.createNewFileListEntryByUser(APIData);
    
      if(data){  return data ;}
      
   } catch (error) {
     
  }
}




